module.exports = __webpack_public_path__ + "static/img/5.36d442a.png";


//////////////////
// WEBPACK FOOTER
// ./static/hz/5.png
// module id = thqO
// module chunks = 202